module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Heavy.79d538d5.woff2";